document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(event) {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-nav]');
  const open = menu.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', open);
});
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-sort-by]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.href = url.toString();
  }
});
